import React from "react";
import { useIntl } from "react-intl";

const CongratulationsPage = ({
  setIsShow,
}: {
  setIsShow: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const intl = useIntl();
  const handlePreview = () => {
    setIsShow(true);
  };

  return (
    <div className="bg-[#c2b39d] flex items-stretch justify-center flex-col py-4 flex-grow">
      <div className="w-full mx-auto max-w-96">
        <div className="flex flex-col items-center justify-center gap-3">
          <h1 className="mb-4 text-3xl font-bold text-white">
            {intl.formatMessage({ id: "wellDone" })}
          </h1>
          <div className="mb-6 text-xl text-center text-[#6e5f49]">
            <p className="mb-2">
              {intl.formatMessage({ id: "congratulationsDescription" })}
            </p>
            <p className="px-2 text-lg">
              {intl.formatMessage({ id: "mailDescription" })}
            </p>
          </div>
          <div className="flex justify-center gap-4">
            <button
              className="px-8 py-2 font-bold text-white bg-[#6b5c45] border-2 border-[#3f3525] rounded animate-bounce hover:border-[#3f3525]"
              onClick={handlePreview}
            >
              {intl.formatMessage({ id: "viewMyQuote" })}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CongratulationsPage;
